import { gql } from "@apollo/client";

export const GET_PROFESIONALES_RI_EV = gql`
query getProfesionalesRIEV($filter: ProfesionalRIEVFilterInput!){
    profesionalesRIEV (filter: $filter) {    
        success,
        error,
        valorEsperado {
            idProfesional,
            profesional
        }
    }
  }
`;